import { User } from './../../models/user';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Context, Menu, TopNavService } from '@optsolservices/ngx-top-nav';
import { GeneralStoreService } from '../../store/general.store';
import { Router, Event } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HelperService } from '../../services/helper.service';
import { NotificationService } from '@optsolservices/ngx-notification';
import { EnvironmentSettings } from '../../models/environment-settings';
import { MatDialog } from '@angular/material/dialog';
import { UserInfoDialogComponent } from '../../components/user-info-dialog/user-info-dialog.component';

@Component({
  selector: 'app-private-layout',
  templateUrl: './private-layout.component.html',
  styleUrls: ['./private-layout.component.scss']
})
export class PrivateLayoutComponent implements OnInit, OnDestroy {
  public environmentSettings: EnvironmentSettings;

  user: User;
  interval = 10;
  versionCode = environment.appVersion;
  applicationCode = environment.appCode;
  versionCheckerUrl = `${environment.apiUrl}/${environment.apiVersion}/generic/command/api_system_application_alive_pulse`;
  public contexts = [];
  public selectedContext = 0;
  public menu = [
    { iconName: 'power_settings_new', label: 'Sign Out' },
    { iconName: 'vpn_key', label: 'Reset Password' },
  ];
  public sideMenuVisible = false;
  public data;

  public badges = [
    { id: 226, badgeCount: 20 },
    { id: 7, badgeCount: 30 },
  ];
  private subscriptions: Subscription[] = [];

  constructor(
    private topNavService: TopNavService,
    private generalStoreService: GeneralStoreService,
    private router: Router,
    private helperService: HelperService,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) { }

  async ngOnInit(): Promise<void> {
    this.subscriptions.push(
      this.generalStoreService.getOwners().subscribe(owners => {
        if (!owners || !(owners.length > 0)) {
          return;
        }
        this.contexts = owners.map(owner => ({ id: owner.id, label: owner.name }));
        const selectedOwner = this.generalStoreService.getSelectedOwnerValue() || owners[0];
        this.generalStoreService.setSelectedOwner(selectedOwner);
        this.selectedContext = selectedOwner.id;
      })


    );

    this.subscriptions.push(
      this.topNavService.getSelectedContext().subscribe((item: Context) => {
        if (!item || !item.id) {
          return;
        }
        const owners = this.generalStoreService.getOwnersValue();
        const selectedOwner = owners.filter(owner => owner.id === item.id).shift();
        this.generalStoreService.setSelectedOwner(selectedOwner);
      })
    );

    this.subscriptions.push(this.generalStoreService.getUser().subscribe(user => this.user = user));

    this.subscriptions.push(this.generalStoreService.getEnvironmentSettings().subscribe(es => this.environmentSettings = es));

    this.subscriptions.push(this.router.events.subscribe((event: Event) => {
      if (this.sideMenuVisible) {
        this.toggleSideMenu();
      }
    }));

    try {
      this.data = await this.helperService.getMenu();
    } catch (error) {
      this.generalStoreService.logout();
      this.router.navigate(['/']);
      this.notificationService.error('You are not linked to any roles, please contact your system administrator.');
      return;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  menuItemClicked(item: Menu): void {
    console.log('menuItemClicked', item);
    if (item.label === 'Sign Out') {
      this.generalStoreService.logout();
      this.router.navigate(['/']);
    } else if (item.label === 'Reset Password') {
      this.generalStoreService.logout();
      this.router.navigate(['/forgot-password']);
      return;
    }
  }

  toggleSideMenu(): void {
    this.sideMenuVisible = !this.sideMenuVisible;
  }

  logout(): void {
    this.generalStoreService.logout();
    this.router.navigate(['/']);
  }

  getUserInfo() {
    const ref = this.dialog.open(UserInfoDialogComponent, {

    });
  }
}
